import React from 'react';
import { classNames } from '@payfit/growth-platform-brand-system-v2';
import { Image } from '@payfit/growth-platform-brand-system-v2/components/Image';

export const PricingPopoverContent = ({
  image,
  title,
  text,
  className,
}: {
  image?: any | null;
  title?: string | null;
  text?: string | null;
  className?: string;
}) => {
  return (
    <div className={classNames('flex flex-col gap-[12px]', className)}>
      {title && <div className={classNames('font-medium')}>{title}</div>}
      {image && (
        <Image
          src={image.url}
          alt={image.alt}
          pixelDensity={'image'}
          width={image.width}
          height={image.height}
          sizes={'284px'}
          className={classNames('w-full rounded-[8px] bg-[#F9F9FB]')}
        />
      )}

      {text && <div dangerouslySetInnerHTML={{ __html: text }} />}
    </div>
  );
};
